import { YatLevelDesignation, YatLevelFloor } from './types';

export function yatLevelFromRhythmScore(rhythmScore: number) {
    if (rhythmScore >= YatLevelFloor.Legendary) {
        return YatLevelDesignation.Legendary;
    }

    if (rhythmScore >= YatLevelFloor.Epic) {
        return YatLevelDesignation.Epic;
    }

    return YatLevelDesignation.Common;
}
